import { Badge } from '@/shared/ui';

export function statusBadge(status: string) {
  if (status === 'active') return <Badge variant="success">Active</Badge>;
  if (status === 'pending') return <Badge variant="warning">Pending</Badge>;
  if (status === 'flagged') return <Badge variant="warning">Flagged</Badge>;
  return <Badge variant="neutral">Blocked</Badge>;
}

export function strategyBadge(strategy: string) {
  if (strategy === 'voice') return <Badge variant="info">Voice</Badge>;
  if (strategy === 'blocked') return <Badge variant="neutral">Blocked</Badge>;
  return <Badge variant="warning">Staff</Badge>;
}
